import {useQuery} from 'react-query'
import {API_URL, FETCH_HEADERS} from "../../constants";
import {handleRequestErrors} from "../../../tools";

export const fetchData = async (id?: string) => {
    return await fetch(`${API_URL}/ship/${id}`, {
        ...FETCH_HEADERS(),
    })
        .then((data) => handleRequestErrors(data))
        .then((data) => {
            return data.json();
        })
        .catch((error) => {
            throw error.message;
        });
}

export default function useShipData(id?: string, onSuccess?: any, onError?: any) {
    return useQuery(['ships', id], () => fetchData(id),
        {
            onSuccess,
            onError,
            keepPreviousData: false,
        }
    );
}